import React, { HTMLAttributes } from 'react';
import './ComplexInputWrapper.scss';
import { IChildrenProp } from 'types/components/components.interface';

interface IComplexInputWrapperProps
  extends IChildrenProp,
    HTMLAttributes<HTMLDivElement> {
  sizes?: number[];
  sizeUnit?: string;
}

const ComplexInputWrapper = ({
  children,
  sizes,
  sizeUnit = '%',
  ...props
}: IComplexInputWrapperProps) => {
  const gridTemplateColumn = `${
    sizes
      ? `${sizes.map(
          size => ` ${size - 4 / (sizes.length + 4)}${sizeUnit}`
        )}`.replaceAll(',', '')
      : 'auto'
  }`;
  return (
    <div
      {...props}
      className={`complex-input-wrapper ${props.className}`}
      style={{
        gridTemplateColumns: gridTemplateColumn,
        ...props.style,
      }}>
      {children}
    </div>
  );
};

export default ComplexInputWrapper;
